import React, { } from 'react';
import PrimaryContainer from "../../../customUI/PrimaryContainer";
import { useStyles } from '../styles/index.style';
import logo from '../../../images/logo-2.svg';

const NoCampaigns = () => {
    const classes = useStyles();

    return (
        <div className={classes.banner_wrapper}>
            <>
              <PrimaryContainer>
                <div style={{ maxWidth: 1000, margin: 'auto' }}>
                  <div className={classes.center}>
                      <img src={logo} className={classes.topLogo} alt="Hennessey Logo" height="75" />
                  </div>
                  <p className={classes.headingTitle}>Enhance your SEO with links search engines will love</p>
                  <p className={classes.paragraph}>
                    Building a trusted link network that points back to your site increases your site&apos;s value to Google and gives potential customers new ways to discover you. As a result, your organic traffic will grow naturally, bringing potential new business to your site. 
                  </p>
                  <p className={classes.paragraph}>
                    Our Digital PR solution focuses on strategic link building campaigns that optimize your SEO through placement of human interest and other timely, strategic stories that reference your company.
                  </p>
                  <div className={classes.center}>
                      <p className={classes.bigText} onClick={() => {
                        window.open(
                          'https://hennessey.zendesk.com/hc/en-us/requests',
                          '_blank'
                        );
                      }}
                      role="presentation"
                      style={{ cursor: 'pointer' }}>Hungry to know more? Contact your Account Manager to discuss or get started.</p>
                  </div>
                </div>
              </PrimaryContainer>
            </>    
        </div>
      );
}

export default NoCampaigns